import { render, staticRenderFns } from "./QRReaderOld.vue?vue&type=template&id=836fa024&scoped=true&"
import script from "./QRReaderOld.vue?vue&type=script&lang=js&"
export * from "./QRReaderOld.vue?vue&type=script&lang=js&"
import style0 from "./QRReaderOld.vue?vue&type=style&index=0&id=836fa024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836fa024",
  null
  
)

export default component.exports